module.exports = __webpack_public_path__ + "img/V4heightLight.9315071b.png";